import { Button } from "@/components/ui/button";
import { Image } from "react-datocms";

export default function TwoColCTA({ cta, style }) {
  const color = cta.color ? cta.color : "";

  const buttonType =
    color === "orange"
      ? "primary"
      : color === "green"
        ? "green"
        : color === "blue"
          ? "seablue"
          : color === "yellow"
            ? "yellow"
            : "secondary";

  return (
    <div style={style}>
      <section className={`cta-bar-${color}`}>
        <div className="w-layout-blockcontainer container-1200 w-container">
          <div className="w-layout-grid cta-bar-grid mobile-gap-48">
            <div className="cta-bar__content">
              {cta.name && (
                <h4 className={`heading-3 mb-4 ${color}`}>{cta.name}</h4>
              )}

              {cta.description && (
                <p className={`body-text mb-6 feature ${buttonType}`}>
                  {cta.description}
                </p>
              )}

              <Button url={cta.url} size="small" variant={buttonType}>
                {cta.buttonText}
              </Button>
            </div>

            <div className="cta-image">
              {cta.image && (
                <Image
                  data={cta.image.responsiveImage}
                  className=""
                  client:visible
                  lazyLoad={false}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
